import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	function navigation(slider) {
		let navWrapper = document.querySelector('.services .keen-navigation')
		let arrowLeft = document.querySelector(
			'.services .keen-navigation .arrow--left'
		)
		let arrowRight = document.querySelector(
			'.services .keen-navigation .arrow--right'
		)

		function updateClasses() {
			var slide = slider.track.details.rel
			slide === 0
				? arrowLeft.setAttribute('disabled', '')
				: arrowLeft.removeAttribute('disabled')
			slide === slider.track.details.maxIdx
				? arrowRight.setAttribute('disabled', '')
				: arrowRight.removeAttribute('disabled')
			slide === 0 && slide === slider.track.details.maxIdx
				? navWrapper.classList.add('hidden')
				: navWrapper.classList.remove('hidden')
		}

		slider.on('created', () => {
			arrowLeft.addEventListener('click', () => slider.prev())
			arrowRight.addEventListener('click', () => slider.next())
			updateClasses()
		})
		slider.on('optionsChanged', () => {
			updateClasses()
		})
		slider.on('slideChanged', () => {
			updateClasses()
		})
	}

	var slider = new KeenSlider(
		'.services-slider.keen-slider',
		{
			breakpoints: {
				'(min-width: 62rem)': {
					slides: {
						perView: 2,
						spacing: 24,
					},
					disabled: false,
				},
				'(min-width: 75rem)': {
					slides: {
						perView: 3,
						spacing: 32,
					},
					disabled: false,
				},
				'(min-width: 120rem)': {
					slides: {
						perView: 4,
						spacing: 32,
					},
					disabled: false,
				},
			},
			slides: {
				perView: 1.05,
				spacing: 24,
			},
			disabled: true,
		},
		[navigation]
	)
})
